var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticleDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 10 3)",
    fill: "#666D80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 10 10)",
    fill: "#666D80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 10 17)",
    fill: "#666D80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticleDots);
export default __webpack_public_path__ + "static/media/verticle-dots.40b3ef7433083871e1c8ca9bf13553ea.svg";
export { ForwardRef as ReactComponent };